(function () {
  var roots = document.querySelectorAll('[data-trade-catalog]');
  if (!roots.length) return;

  // ── Analytics ──────────────────────────────────────────────────────────
  // Uses the theme's global dataLayer stack (datalayer-init.liquid). All calls
  // are guarded so they no-op when analytics is disabled or not yet loaded.
  function ktPush(payload) {
    try {
      if (window.KT && window.KT.DataLayer && typeof window.KT.DataLayer.push === 'function') {
        window.KT.DataLayer.push(payload);
      } else {
        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push(payload);
      }
    } catch (e) { /* never break the page on a tracking error */ }
  }

  function ktEcom(method, args) {
    try {
      if (window.KT && window.KT.EcommerceEvents && typeof window.KT.EcommerceEvents[method] === 'function') {
        window.KT.EcommerceEvents[method].apply(window.KT.EcommerceEvents, args);
      }
    } catch (e) { /* no-op */ }
  }

  // Shape a catalog product for the theme's formatProduct(). Prices are withheld
  // in the trade catalog, so price is sent as 0.
  function ktEcomItem(product) {
    return {
      id: product.id || product.handle,
      title: product.title,
      product_type: product.productType,
      vendor: product.vendor,
      sku: product.sku,
      price: 0
    };
  }

  function uniqueSorted(values) {
    return Array.from(new Set(values.filter(Boolean))).sort(function (a, b) {
      return a.localeCompare(b);
    });
  }

  function absoluteUrl(url) {
    if (!url) return window.location.origin;
    if (/^https?:\/\//.test(url)) return url;
    return window.location.origin + (url.charAt(0) === '/' ? url : '/' + url);
  }

  function copyText(text) {
    if (navigator.clipboard && navigator.clipboard.writeText) {
      return navigator.clipboard.writeText(text);
    }

    var textarea = document.createElement('textarea');
    textarea.value = text;
    textarea.setAttribute('readonly', '');
    textarea.style.position = 'fixed';
    textarea.style.opacity = '0';
    document.body.appendChild(textarea);
    textarea.select();
    document.execCommand('copy');
    textarea.remove();
    return Promise.resolve();
  }

  function createOption(value, label) {
    var option = document.createElement('option');
    option.value = value;
    option.textContent = label;
    return option;
  }

  function stripHtml(html) {
    var div = document.createElement('div');
    div.innerHTML = html || '';
    return (div.textContent || div.innerText || '').replace(/\s+/g, ' ').trim();
  }

  function variantAvailable(variant) {
    return variant && variant.available !== false;
  }

  function normalizePublicProduct(raw, collection) {
    var variants = Array.isArray(raw.variants) ? raw.variants : [];
    var primaryVariant = variants.find(variantAvailable) || variants[0] || {};
    var image = raw.image && raw.image.src ? raw.image.src : raw.images && raw.images[0] && raw.images[0].src;

    if (!raw.title || !raw.handle || !image || !variants.some(variantAvailable)) {
      return null;
    }

    return {
      id: String(raw.id || raw.handle),
      title: raw.title,
      handle: raw.handle,
      vendor: raw.vendor || '',
      productType: raw.product_type || '',
      tags: Array.isArray(raw.tags) ? raw.tags : [],
      imageUrl: image,
      imageAlt: raw.title,
      productUrl: '/products/' + raw.handle,
      description: stripHtml(raw.body_html).slice(0, 180),
      sku: primaryVariant.sku || '',
      availableForSale: true,
      variants: variants.map(function (variant) {
        return {
          id: String(variant.id || ''),
          title: variant.title || '',
          sku: variant.sku || '',
          availableForSale: variant.available !== false
        };
      }),
      collections: [collection]
    };
  }

  function buildFallbackCatalog(products) {
    var byHandle = new Map();
    products.filter(Boolean).forEach(function (product) {
      var existing = byHandle.get(product.handle);
      if (existing) {
        var handles = new Set(existing.collections.map(function (collection) { return collection.handle; }));
        product.collections.forEach(function (collection) {
          if (!handles.has(collection.handle)) existing.collections.push(collection);
        });
      } else {
        byHandle.set(product.handle, product);
      }
    });

    var catalogProducts = Array.from(byHandle.values()).sort(function (a, b) {
      return a.title.localeCompare(b.title);
    });

    // Build the category list dynamically from the products that actually loaded,
    // rather than a fixed collection list, so every category is represented.
    var countByHandle = {};
    var titleByHandle = {};
    catalogProducts.forEach(function (product) {
      (product.collections || []).forEach(function (collection) {
        if (!collection || !collection.handle) return;
        countByHandle[collection.handle] = (countByHandle[collection.handle] || 0) + 1;
        titleByHandle[collection.handle] = collection.title || collection.handle;
      });
    });
    var collections = Object.keys(countByHandle).map(function (handle) {
      return { handle: handle, title: titleByHandle[handle], count: countByHandle[handle] };
    }).sort(function (a, b) {
      return b.count - a.count || a.title.localeCompare(b.title);
    });

    return {
      summary: {
        productCount: catalogProducts.length,
        collectionCount: collections.length,
        availableOnly: true
      },
      collections: collections,
      products: catalogProducts,
      source: 'shopify-public-collection-json'
    };
  }

  function slugifyType(value) {
    return String(value || 'other').toLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/^-+|-+$/g, '') || 'other';
  }

  function typeCollection(productType) {
    var title = String(productType || '').trim();
    return { handle: 'type-' + slugifyType(title), title: title || 'Other products' };
  }

  // Fetch every published product via /collections/all, paginated. Shopify caps
  // products.json at 250/page; we page through in small parallel batches until a
  // short/empty page signals the end.
  function fetchAllPublicProductsRaw() {
    var LIMIT = 250;
    var MAX_PAGES = 80;
    var BATCH = 6;
    var all = [];
    var nextPage = 1;
    var done = false;

    function fetchPage(page) {
      return fetchJson('/collections/all/products.json?limit=' + LIMIT + '&page=' + page)
        .then(function (payload) { return (payload && payload.products) || []; })
        .catch(function () { return null; });
    }

    function runBatch() {
      if (done || nextPage > MAX_PAGES) return Promise.resolve(all);
      var pages = [];
      for (var i = 0; i < BATCH && nextPage <= MAX_PAGES; i += 1, nextPage += 1) {
        pages.push(fetchPage(nextPage));
      }
      return Promise.all(pages).then(function (results) {
        results.forEach(function (products) {
          if (products === null) { done = true; return; }
          if (products.length < LIMIT) done = true;
          all = all.concat(products);
        });
        return done ? all : runBatch();
      });
    }

    return runBatch();
  }

  function fetchJson(url) {
    return fetch(url, { headers: { Accept: 'application/json' } }).then(function (response) {
      var contentType = response.headers.get('content-type') || '';
      if (!response.ok || contentType.indexOf('application/json') === -1) {
        throw new Error('Catalog response was not JSON');
      }
      return response.json();
    });
  }

  function fetchPublicCatalog() {
    return fetchAllPublicProductsRaw().then(function (rawProducts) {
      var products = rawProducts.map(function (raw) {
        return normalizePublicProduct(raw, typeCollection(raw.product_type));
      });
      return buildFallbackCatalog(products);
    });
  }

  function sha256(value) {
    if (!window.crypto || !window.crypto.subtle || !window.TextEncoder) {
      return Promise.reject(new Error('Password check is not supported by this browser'));
    }

    return window.crypto.subtle.digest('SHA-256', new TextEncoder().encode(value)).then(function (buffer) {
      return Array.from(new Uint8Array(buffer)).map(function (byte) {
        return byte.toString(16).padStart(2, '0');
      }).join('');
    });
  }

  function init(root) {
    var state = {
      products: [],
      collections: [],
      activeCollection: '',
      selected: new Map(),
      query: '',
      brand: '',
      type: '',
      sort: 'featured',
      visibleLimit: 240
    };

    var isTradeCustomer = root.getAttribute('data-trade-customer') === 'true';
    var endpoint = root.getAttribute('data-catalog-endpoint') || '/apps/visual-commerce/api/catalog';
    var csvEndpoint = root.getAttribute('data-csv-endpoint') || '/apps/visual-commerce/api/catalog.csv';
    var passwordRequired = root.getAttribute('data-catalog-password-required') === 'true';
    var passwordHash = root.getAttribute('data-catalog-password-hash') || '';
    var unlockKey = 'kt-trade-catalog-unlocked:' + passwordHash.slice(0, 12);

    var gate = root.querySelector('[data-catalog-gate]');
    var gateForm = root.querySelector('[data-catalog-gate-form]');
    var passwordInput = root.querySelector('[data-catalog-password]');
    var passwordError = root.querySelector('[data-catalog-password-error]');
    var searchInput = root.querySelector('[data-catalog-search]');
    var brandSelect = root.querySelector('[data-catalog-brand]');
    var typeSelect = root.querySelector('[data-catalog-type]');
    var sortSelect = root.querySelector('[data-catalog-sort]');
    var rail = root.querySelector('[data-catalog-rail]');
    var grid = root.querySelector('[data-catalog-grid]');
    var status = root.querySelector('[data-catalog-status]');
    var meta = root.querySelector('[data-catalog-meta]');
    var fallbackNotice = root.querySelector('[data-catalog-fallback-notice]');
    var empty = root.querySelector('[data-catalog-empty]');
    var loadMore = root.querySelector('[data-catalog-load-more]');
    var clearButton = root.querySelector('[data-catalog-clear]');
    var csvLink = root.querySelector('[data-catalog-csv]');
    var printButton = root.querySelector('[data-catalog-print]');
    var tradePrompt = root.querySelector('[data-catalog-trade-prompt]');
    var tray = root.querySelector('[data-catalog-tray]');
    var trayCount = root.querySelector('[data-catalog-tray-count]');
    var quoteLink = root.querySelector('[data-catalog-quote]');
    var copyList = root.querySelector('[data-catalog-copy-list]');
    var heroCount = root.querySelector('[data-catalog-hero-count]');
    var heroCats = root.querySelector('[data-catalog-hero-cats]');
    var workspace = root.querySelector('[data-catalog-workspace]') || root.querySelector('.kt-trade-catalog__workspace');

    function setLocked(locked) {
      if (gate) gate.hidden = !locked;
      if (workspace) workspace.hidden = locked;
      if (tray) tray.hidden = true;
    }

    if (passwordRequired && passwordHash && window.localStorage.getItem(unlockKey) !== '1') {
      setLocked(true);
    }

    if (gateForm) {
      gateForm.addEventListener('submit', function (event) {
        event.preventDefault();
        var password = passwordInput ? passwordInput.value : '';
        sha256(password).then(function (digest) {
          if (digest !== passwordHash) {
            if (passwordError) passwordError.hidden = false;
            return;
          }
          window.localStorage.setItem(unlockKey, '1');
          if (passwordInput) passwordInput.value = '';
          if (passwordError) passwordError.hidden = true;
          setLocked(false);
        }).catch(function () {
          if (passwordError) {
            passwordError.textContent = 'Password unlock is not supported in this browser.';
            passwordError.hidden = false;
          }
        });
      });
    }

    if (isTradeCustomer) {
      if (csvLink) {
        csvLink.hidden = false;
        csvLink.href = csvEndpoint;
      }
      if (tradePrompt) tradePrompt.hidden = true;
    }

    // Analytics: downloads and quote-request funnel clicks (the actual
    // generate_lead conversion still fires from the quote form on submit).
    if (csvLink) {
      csvLink.addEventListener('click', function () {
        ktPush({
          event: 'file_download',
          file_name: 'kent-traders-live-trade-catalog.csv',
          file_extension: 'csv',
          link_text: 'Download CSV',
          source: 'trade_catalog'
        });
      });
    }
    if (tradePrompt) {
      tradePrompt.addEventListener('click', function () {
        ktPush({ event: 'catalog_request_quote', request_type: 'pricing', source: 'trade_catalog' });
      });
    }
    if (quoteLink) {
      quoteLink.addEventListener('click', function () {
        ktPush({
          event: 'catalog_request_quote',
          request_type: 'quote',
          source: 'trade_catalog',
          selected_products: state.selected.size
        });
      });
    }

    function productMatches(product) {
      var haystack = [
        product.title,
        product.vendor,
        product.productType,
        (product.collections || []).map(function (collection) { return collection.title; }).join(' ')
      ].join(' ').toLowerCase();

      var collectionMatch = !state.activeCollection || (product.collections || []).some(function (collection) {
        return collection.handle === state.activeCollection;
      });

      return collectionMatch &&
        (!state.query || haystack.indexOf(state.query) !== -1) &&
        (!state.brand || product.vendor === state.brand) &&
        (!state.type || product.productType === state.type);
    }

    function sortProducts(products) {
      var sorted = products.slice();
      if (state.sort === 'title-asc') {
        sorted.sort(function (a, b) { return (a.title || '').localeCompare(b.title || ''); });
      } else if (state.sort === 'title-desc') {
        sorted.sort(function (a, b) { return (b.title || '').localeCompare(a.title || ''); });
      } else if (state.sort === 'brand-asc') {
        sorted.sort(function (a, b) {
          return (a.vendor || '').localeCompare(b.vendor || '') || (a.title || '').localeCompare(b.title || '');
        });
      }
      return sorted;
    }

    function filteredProducts() {
      return sortProducts(state.products.filter(productMatches));
    }

    function renderFilters() {
      uniqueSorted(state.products.map(function (product) { return product.vendor; })).forEach(function (vendor) {
        brandSelect.appendChild(createOption(vendor, vendor));
      });

      uniqueSorted(state.products.map(function (product) { return product.productType; })).forEach(function (type) {
        typeSelect.appendChild(createOption(type, type));
      });
    }

    function renderRail() {
      rail.innerHTML = '';
      var allButton = document.createElement('button');
      allButton.type = 'button';
      allButton.textContent = 'All available';
      allButton.setAttribute('aria-pressed', state.activeCollection === '' ? 'true' : 'false');
      allButton.addEventListener('click', function () {
        state.activeCollection = '';
        state.visibleLimit = 240;
        render();
      });
      rail.appendChild(allButton);

      // Cap the rail to the largest categories to keep it scannable; the full list
      // remains available via the Product type filter. Always include the active one.
      var RAIL_MAX = 24;
      var railCollections = state.collections.slice(0, RAIL_MAX);
      if (state.activeCollection && !railCollections.some(function (c) { return c.handle === state.activeCollection; })) {
        var active = state.collections.filter(function (c) { return c.handle === state.activeCollection; })[0];
        if (active) railCollections = railCollections.concat(active);
      }

      railCollections.forEach(function (collection) {
        var button = document.createElement('button');
        button.type = 'button';
        button.textContent = collection.title + ' (' + collection.count + ')';
        button.setAttribute('aria-pressed', state.activeCollection === collection.handle ? 'true' : 'false');
        button.addEventListener('click', function () {
          state.activeCollection = collection.handle;
          state.visibleLimit = 240;
          render();
        });
        rail.appendChild(button);
      });
    }

    function productCard(product, index) {
      var article = document.createElement('article');
      article.className = 'kt-catalog-product';
      article.style.animationDelay = Math.min(index * 18, 180) + 'ms';

      var imageLink = document.createElement('a');
      imageLink.className = 'kt-catalog-product__image';
      imageLink.href = product.productUrl;

      var image = document.createElement('img');
      image.src = product.imageUrl;
      image.alt = product.imageAlt || product.title;
      image.loading = index < 6 ? 'eager' : 'lazy';
      image.decoding = 'async';
      image.width = 420;
      image.height = 315;
      imageLink.appendChild(image);

      var body = document.createElement('div');
      body.className = 'kt-catalog-product__body';

      var kicker = document.createElement('div');
      kicker.className = 'kt-catalog-product__kicker';
      var vendor = document.createElement('span');
      vendor.textContent = product.vendor || 'Kent Traders';
      var available = document.createElement('span');
      available.className = 'kt-catalog-product__available';
      available.textContent = 'Available';
      kicker.append(vendor, available);

      var title = document.createElement('h3');
      var titleLink = document.createElement('a');
      titleLink.href = product.productUrl;
      titleLink.textContent = product.title;
      title.appendChild(titleLink);

      var desc = document.createElement('p');
      desc.className = 'kt-catalog-product__description';
      desc.textContent = product.description || 'Available for trade procurement from Kent Traders.';

      var specs = document.createElement('div');
      specs.className = 'kt-catalog-product__specs';
      [product.productType, 'Price on request'].filter(Boolean).forEach(function (spec) {
        var pill = document.createElement('span');
        pill.textContent = spec;
        if (spec === 'Price on request') pill.className = 'is-price';
        specs.appendChild(pill);
      });

      var actions = document.createElement('div');
      actions.className = 'kt-catalog-product__actions';

      var view = document.createElement('a');
      view.className = 'kt-trade-catalog__button kt-trade-catalog__button--small';
      view.href = product.productUrl;
      view.textContent = 'View product';
      view.addEventListener('click', function () {
        ktEcom('selectItem', [ktEcomItem(product), 'Trade Catalog']);
      });

      var copy = document.createElement('button');
      copy.type = 'button';
      copy.className = 'kt-trade-catalog__button kt-trade-catalog__button--small';
      copy.textContent = 'Copy link';
      copy.addEventListener('click', function () {
        copyText(absoluteUrl(product.productUrl)).then(function () {
          copy.textContent = 'Copied';
          window.setTimeout(function () { copy.textContent = 'Copy link'; }, 1200);
        });
      });

      var compare = document.createElement('button');
      compare.type = 'button';
      compare.className = 'kt-trade-catalog__button kt-trade-catalog__button--small';
      compare.textContent = state.selected.has(product.handle) ? 'Selected' : 'Compare';
      compare.addEventListener('click', function () {
        if (state.selected.has(product.handle)) {
          state.selected.delete(product.handle);
        } else {
          state.selected.set(product.handle, product);
        }
        renderTray();
        render();
      });

      actions.append(view, copy, compare);
      body.append(kicker, title, desc, specs, actions);
      article.append(imageLink, body);
      return article;
    }

    function renderTray() {
      var selected = Array.from(state.selected.values());
      tray.hidden = selected.length === 0;
      trayCount.textContent = selected.length + (selected.length === 1 ? ' selected' : ' selected');

      var quoteParams = new URLSearchParams();
      quoteParams.set('catalog_products', selected.map(function (product) { return product.title; }).join(' | '));
      quoteLink.href = '/pages/request-a-quote?' + quoteParams.toString();
    }

    function renderSkeleton(count) {
      grid.innerHTML = '';
      for (var i = 0; i < count; i += 1) {
        var card = document.createElement('div');
        card.className = 'kt-catalog-skeleton';
        card.setAttribute('aria-hidden', 'true');
        card.innerHTML =
          '<div class="kt-catalog-skeleton__image"></div>' +
          '<div class="kt-catalog-skeleton__body">' +
          '<span class="kt-catalog-skeleton__line kt-catalog-skeleton__line--sm"></span>' +
          '<span class="kt-catalog-skeleton__line"></span>' +
          '<span class="kt-catalog-skeleton__line kt-catalog-skeleton__line--md"></span>' +
          '<span class="kt-catalog-skeleton__line kt-catalog-skeleton__line--btn"></span>' +
          '</div>';
        grid.appendChild(card);
      }
    }

    function render() {
      var products = filteredProducts();
      grid.innerHTML = '';
      products.slice(0, state.visibleLimit).forEach(function (product, index) {
        grid.appendChild(productCard(product, index));
      });

      status.textContent = products.length + ' available products';
      meta.textContent = state.products.length + ' live sellable products loaded. Out-of-stock products are excluded.';
      empty.hidden = products.length > 0;
      if (loadMore) loadMore.hidden = products.length <= state.visibleLimit;
      renderRail();
      renderTray();
    }

    function updateFallbackNotice(catalog) {
      if (!fallbackNotice) return;
      var source = String(catalog && catalog.source ? catalog.source : '');
      var isFallback = source.indexOf('public') !== -1 || source.indexOf('fallback') !== -1;
      fallbackNotice.hidden = !isFallback;
    }

    var searchTrackTimer;
    searchInput.addEventListener('input', function () {
      state.query = searchInput.value.trim().toLowerCase();
      state.visibleLimit = 240;
      render();
      // Debounced GA4 search event once the shopper stops typing.
      window.clearTimeout(searchTrackTimer);
      searchTrackTimer = window.setTimeout(function () {
        if (state.query.length >= 2) ktEcom('search', [state.query, filteredProducts().length]);
      }, 800);
    });

    brandSelect.addEventListener('change', function () {
      state.brand = brandSelect.value;
      state.visibleLimit = 240;
      render();
    });

    typeSelect.addEventListener('change', function () {
      state.type = typeSelect.value;
      state.visibleLimit = 240;
      render();
    });

    if (sortSelect) {
      sortSelect.addEventListener('change', function () {
        state.sort = sortSelect.value;
        state.visibleLimit = 240;
        render();
      });
    }

    clearButton.addEventListener('click', function () {
      state.activeCollection = '';
      state.query = '';
      state.brand = '';
      state.type = '';
      state.sort = 'featured';
      state.visibleLimit = 240;
      searchInput.value = '';
      brandSelect.value = '';
      typeSelect.value = '';
      if (sortSelect) sortSelect.value = 'featured';
      render();
    });

    // The storefront theme colours every <a> with a very high-specificity
    // !important rule (a:not(.btn):not(.t4s-btn)…:hover), which overrides the CSS
    // hover colour on our link-buttons. Force white via an inline style on
    // hover/focus (inline !important beats stylesheet !important). Delegated on the
    // root so it also covers dynamically rendered product-card buttons.
    function ktLinkButtonFrom(event) {
      return event.target && event.target.closest
        ? event.target.closest('a.kt-trade-catalog__button')
        : null;
    }
    function ktLinkButtonWhite(event) {
      var btn = ktLinkButtonFrom(event);
      if (btn) btn.style.setProperty('color', '#ffffff', 'important');
    }
    function ktLinkButtonReset(event) {
      var btn = ktLinkButtonFrom(event);
      if (btn) btn.style.removeProperty('color');
    }
    root.addEventListener('mouseover', ktLinkButtonWhite);
    root.addEventListener('mouseout', ktLinkButtonReset);
    root.addEventListener('focusin', ktLinkButtonWhite);
    root.addEventListener('focusout', ktLinkButtonReset);

    if (loadMore) {
      loadMore.addEventListener('click', function () {
        state.visibleLimit += 240;
        render();
      });
    }

    var brandLogo = root.getAttribute('data-catalog-logo') || '';
    var brandName = root.getAttribute('data-catalog-brand-name') || 'Kent Traders';
    var brandUrl = root.getAttribute('data-catalog-brand-url') || window.location.origin;

    function escapeHtml(value) {
      return String(value == null ? '' : value).replace(/[&<>"']/g, function (ch) {
        return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[ch];
      });
    }

    // Group products into categories using the priority-ordered collection list
    // so the PDF has proper, navigable sections.
    function groupProductsByCategory(products) {
      var order = state.collections.map(function (c) { return c.handle; });
      var titleByHandle = {};
      state.collections.forEach(function (c) { titleByHandle[c.handle] = c.title; });

      var groups = {};
      products.forEach(function (product) {
        var handles = (product.collections || []).map(function (c) { return c.handle; });
        var chosen = null;
        for (var i = 0; i < order.length; i += 1) {
          if (handles.indexOf(order[i]) !== -1) { chosen = order[i]; break; }
        }
        if (!chosen) {
          chosen = (product.collections && product.collections[0] && product.collections[0].handle) || 'other';
          if (!titleByHandle[chosen]) {
            titleByHandle[chosen] = (product.collections && product.collections[0] && product.collections[0].title) || 'Other';
          }
        }
        if (!groups[chosen]) groups[chosen] = { handle: chosen, title: titleByHandle[chosen] || 'Other', items: [] };
        groups[chosen].items.push(product);
      });

      var ordered = [];
      order.forEach(function (h) { if (groups[h]) { ordered.push(groups[h]); delete groups[h]; } });
      Object.keys(groups).forEach(function (h) { ordered.push(groups[h]); });
      ordered.forEach(function (g) {
        g.items.sort(function (a, b) { return (a.title || '').localeCompare(b.title || ''); });
      });
      return ordered;
    }

    // Request a small CDN thumbnail so the PDF loads fast (full images are huge).
    function pdfThumb(url) {
      if (!url) return '';
      var sep = url.indexOf('?') > -1 ? '&' : '?';
      return url + sep + 'width=110';
    }

    function catalogProductRow(product) {
      var img = product.imageUrl
        ? '<img class="pi" src="' + escapeHtml(pdfThumb(product.imageUrl)) + '" alt="" loading="eager">'
        : '';
      return '<tr>' +
        '<td class="c-img">' + img + '</td>' +
        '<td><div class="t">' + escapeHtml(product.title) + '</div>' +
        (product.description ? '<div class="d">' + escapeHtml(product.description) + '</div>' : '') + '</td>' +
        '<td>' + escapeHtml(product.vendor || '') + '</td>' +
        '<td>' + escapeHtml(product.productType || '') + '</td>' +
        '<td class="price">Price on request</td>' +
        '</tr>';
    }

    function buildCatalogPdfDocument(products) {
      var when = new Date().toLocaleDateString('en-GB', { day: 'numeric', month: 'long', year: 'numeric' });
      var domain = brandUrl.replace(/^https?:\/\//, '').replace(/\/$/, '');
      var groups = groupProductsByCategory(products);

      var brandMark = brandLogo
        ? '<img class="logo" src="' + escapeHtml(brandLogo) + '" alt="' + escapeHtml(brandName) + '">'
        : '<div class="bn">' + escapeHtml(brandName) + '</div>';

      var cover = '<section class="cover">' + brandMark +
        '<h1>Trade Catalogue</h1><div class="rule"></div>' +
        '<p class="lead">' + escapeHtml(brandName) + ' - available electrical, hospitality and bathroom products for architects, contractors and trade procurement teams. Out-of-stock lines are excluded.</p>' +
        '<div class="stat">' + products.length + ' products &middot; ' + groups.length + ' categories &middot; ' + escapeHtml(when) + '</div>' +
        '<div class="cta">Prices supplied on request. To order or request pricing, contact <b>support@' + escapeHtml(domain) + '</b> &middot; ' + escapeHtml(domain) + '</div>' +
        '</section>';

      var toc = '';
      if (groups.length > 1) {
        toc = '<section class="toc" id="toc"><h2>Contents</h2><ol>' +
          groups.map(function (g) {
            return '<li><a href="#cat-' + escapeHtml(g.handle) + '"><span class="tt">' + escapeHtml(g.title) + '</span><span class="n">' + g.items.length + '</span></a></li>';
          }).join('') +
          '</ol></section>';
      }

      var body = groups.map(function (g) {
        var rows = g.items.map(catalogProductRow).join('') ||
          '<tr><td colspan="5" class="empty">No products in this category.</td></tr>';
        var back = groups.length > 1 ? '<a class="back" href="#toc">Back to contents</a>' : '';
        return '<section class="cat" id="cat-' + escapeHtml(g.handle) + '">' +
          '<div class="catmeta"><h2>' + escapeHtml(g.title) + ' <span class="cc">(' + g.items.length + ')</span></h2>' + back + '</div>' +
          '<table><thead><tr><th></th><th>Product</th><th>Brand</th><th>Type</th><th>Pricing</th></tr></thead>' +
          '<tbody>' + rows + '</tbody></table>' +
          '</section>';
      }).join('');

      var footer = '<div class="pagefoot"><span>' + escapeHtml(brandName) + ' - Trade Catalogue</span>' +
        '<span>Prices on request &middot; ' + escapeHtml(domain) + '</span></div>';

      return '<!doctype html><html lang="en"><head><meta charset="utf-8">' +
        '<title>' + escapeHtml(brandName) + ' - Trade Catalogue</title>' +
        '<style>' +
        '@page{margin:14mm 12mm 18mm;}' +
        '*{box-sizing:border-box;}' +
        'body{margin:0;font-family:Arial,Helvetica,sans-serif;color:#141414;-webkit-print-color-adjust:exact;print-color-adjust:exact;}' +
        'a{color:inherit;text-decoration:none;}' +
        '.cover{min-height:232mm;display:flex;flex-direction:column;justify-content:center;text-align:center;break-after:page;}' +
        '.cover .logo{height:62px;width:auto;margin:0 auto 24px;}' +
        '.cover .bn{font-size:26px;font-weight:800;color:#111315;margin-bottom:24px;}' +
        '.cover h1{font-size:40px;color:#111315;margin:0;}' +
        '.cover .rule{width:78px;height:4px;background:#d8b569;margin:14px auto 18px;}' +
        '.cover .lead{max-width:520px;margin:0 auto;font-size:13px;line-height:1.6;color:#62656b;}' +
        '.cover .stat{margin-top:22px;font-size:12px;font-weight:700;letter-spacing:.08em;text-transform:uppercase;color:#111315;}' +
        '.cover .cta{margin-top:12px;font-size:11px;color:#62656b;}' +
        '.toc{break-after:page;}' +
        '.toc h2,.cat h2{font-size:15px;text-transform:uppercase;letter-spacing:.07em;color:#111315;margin:0 0 12px;}' +
        '.toc h2{border-bottom:3px solid #d8b569;padding-bottom:8px;}' +
        '.toc ol{list-style:none;margin:0;padding:0;columns:2;column-gap:34px;}' +
        '.toc li{break-inside:avoid;margin:0 0 4px;}' +
        '.toc a{display:flex;justify-content:space-between;gap:12px;border-bottom:1px dotted #cfc7b6;padding:7px 0;font-size:12px;}' +
        '.toc .n{color:#6b5312;font-weight:700;}' +
        '.cat{break-before:page;}' +
        '.cat .catmeta{display:flex;justify-content:space-between;align-items:baseline;border-bottom:3px solid #d8b569;padding-bottom:8px;margin-bottom:12px;}' +
        '.cat h2{margin:0;border:0;}' +
        '.cat .cc{color:#6b5312;}' +
        '.cat .back{font-size:9px;letter-spacing:.08em;text-transform:uppercase;color:#6b5312;}' +
        'table{width:100%;border-collapse:collapse;font-size:10.5px;}' +
        'thead{display:table-header-group;}' +
        'thead th{background:#111315;color:#fff;text-align:left;padding:7px 8px;font-size:9px;letter-spacing:.08em;text-transform:uppercase;}' +
        'tbody td{padding:8px;border-bottom:1px solid #e7e0d2;vertical-align:top;}' +
        'tbody tr{break-inside:avoid;}' +
        'tbody tr:nth-child(even){background:#faf7f0;}' +
        '.c-img{width:62px;}' +
        '.pi{width:54px;height:54px;object-fit:contain;mix-blend-mode:multiply;}' +
        '.t{font-weight:700;color:#101828;}' +
        '.d{color:#62656b;font-size:9.5px;margin-top:2px;}' +
        '.price{color:#6b5312;font-weight:700;white-space:nowrap;}' +
        '.empty{text-align:center;color:#62656b;padding:24px;}' +
        '.pagefoot{position:fixed;left:0;right:0;bottom:0;display:flex;justify-content:space-between;padding:6px 4px;font-size:8.5px;color:#8a8578;border-top:1px solid #e7e0d2;background:#fff;}' +
        '</style></head><body>' +
        footer + cover + toc + body +
        '<script>(function(){var done=false;function go(){if(done)return;done=true;window.focus();window.print();}window.addEventListener("load",go);setTimeout(go,1500);}());<\/script>' +
        '</body></html>';
    }

    function downloadCatalogPdf() {
      var products = filteredProducts();
      ktPush({
        event: 'file_download',
        file_name: 'kent-traders-trade-catalogue.pdf',
        file_extension: 'pdf',
        link_text: 'Download catalog PDF',
        source: 'trade_catalog',
        product_count: products.length
      });
      var html = buildCatalogPdfDocument(products);

      // Print via a hidden, same-origin iframe instead of window.open + a
      // window.print() fallback. Two wins: (1) no popup-blocker dependency, and
      // (2) it NEVER calls window.print() on the storefront document — the old
      // popup-blocked fallback did, which froze the page (a modal, synchronous
      // print) and triggered the beforeprint handler to re-render the entire
      // catalog into the live DOM. The generated doc carries its own
      // print-on-load script (see buildCatalogPdfDocument), so the iframe prints
      // itself; we only handle cleanup here.
      var iframe = document.createElement('iframe');
      iframe.setAttribute('aria-hidden', 'true');
      iframe.setAttribute('tabindex', '-1');
      iframe.style.cssText = 'position:fixed;right:0;bottom:0;width:0;height:0;border:0;visibility:hidden;';

      var cleaned = false;
      function cleanup() {
        if (cleaned) return;
        cleaned = true;
        setTimeout(function () {
          if (iframe && iframe.parentNode) iframe.parentNode.removeChild(iframe);
        }, 1000);
      }

      try {
        document.body.appendChild(iframe);
        var idoc = iframe.contentWindow.document;
        idoc.open();
        idoc.write(html);
        idoc.close();
        // Remove the iframe once the print dialog closes; 60s safety net in case
        // afterprint never fires (some browsers) or the dialog is left open.
        try { iframe.contentWindow.addEventListener('afterprint', cleanup); } catch (e) { /* same-origin only */ }
        setTimeout(cleanup, 60000);
      } catch (e) {
        // Last resort — still never window.print() the main page. Open a new tab
        // the user can print/save from (self-prints via its own on-load script).
        cleanup();
        var win = window.open('', '_blank');
        if (win) {
          win.document.open();
          win.document.write(html);
          win.document.close();
        }
      }
    }

    if (printButton) {
      printButton.addEventListener('click', downloadCatalogPdf);
    }

    // Expand all filtered products before printing so the saved PDF contains the
    // full catalog rather than being capped at the on-screen visible limit.
    var printLimitBackup = null;
    window.addEventListener('beforeprint', function () {
      printLimitBackup = state.visibleLimit;
      state.visibleLimit = Number.MAX_SAFE_INTEGER;
      render();
    });
    window.addEventListener('afterprint', function () {
      if (printLimitBackup === null) return;
      state.visibleLimit = printLimitBackup;
      printLimitBackup = null;
      render();
    });

    if (copyList) {
      copyList.addEventListener('click', function () {
        var links = Array.from(state.selected.values()).map(function (product) {
          return product.title + ': ' + absoluteUrl(product.productUrl);
        }).join('\n');
        copyText(links).then(function () {
          copyList.textContent = 'Copied';
          window.setTimeout(function () { copyList.textContent = 'Copy links'; }, 1200);
        });
      });
    }

    renderSkeleton(8);

    fetchJson(endpoint)
      .then(function (payload) {
        return payload.catalog || {};
      })
      .catch(fetchPublicCatalog)
      .then(function (catalog) {
        updateFallbackNotice(catalog);
        state.products = Array.isArray(catalog.products) ? catalog.products.map(function (product) {
          var sanitized = Object.assign({}, product);
          delete sanitized.price;
          delete sanitized.compareAtPrice;
          sanitized.variants = Array.isArray(product.variants) ? product.variants.map(function (variant) {
            return {
              id: variant.id,
              title: variant.title,
              sku: variant.sku,
              availableForSale: variant.availableForSale !== false
            };
          }) : [];
          return sanitized;
        }) : [];
        state.collections = Array.isArray(catalog.collections) ? catalog.collections : [];
        if (!state.products.length) throw new Error('Catalog contained no products');
        if (heroCount) heroCount.textContent = state.products.length.toLocaleString('en-GB');
        if (heroCats) heroCats.textContent = state.collections.length;
        renderFilters();
        render();
        // Analytics: catalog loaded + product-list impression (GA4 view_item_list).
        ktPush({
          event: 'trade_catalog_loaded',
          product_count: state.products.length,
          category_count: state.collections.length,
          catalog_source: catalog.source || 'unknown'
        });
        ktEcom('viewItemList', ['Trade Catalog', state.products.slice(0, 30).map(ktEcomItem)]);
      })
      .catch(function () {
        status.textContent = 'Catalog is temporarily unavailable';
        meta.textContent = 'Please try again shortly or contact the trade team for the latest product list.';
        empty.hidden = false;
      });
  }

  roots.forEach(init);
})();
